import React from 'react';
import { useAuthRedirect } from '../../hooks/useAuthRedirect';

export default function ProtectedRoute({ children }) {
  // This will redirect to login if user is not authenticated
  useAuthRedirect('/login', false);
  
  return children;
} 